import axios, {AxiosResponse} from 'axios';
import stringify from 'fast-json-stable-stringify';
import LRUCache from 'lru-cache';
import qs from "qs";

import environment from '../../configs/environment.config';
import {cacheAdapterEnhancer} from '../adapters/axiosCache.adapter';
import dedupeAdapter from '../adapters/dedupe.adapter';
import {middlewareRequestInterceptor} from '../interceptors/middleware.requestInterceptor';
import {middlewareResponseErrorInterceptor} from '../interceptors/middleware.responseErrorInterceptor';
import {middlewareResponseInterceptor} from '../interceptors/middleware.responseInterceptor';

const sentinelMw = axios.create({
    baseURL: `${environment.baseURL}/sentinel/`,
    adapter: cacheAdapterEnhancer(
        environment.testEnv ? axios.defaults.adapter : dedupeAdapter,
        {
            enabledByDefault: false,
            cacheFlag: 'useCache',
            defaultCache: new LRUCache({
                maxAge: environment.cacheMaxAge
            }),
            customCacheKeyGenerator: (req) => stringify({
                url: req.url,
                data: req.data,
                params: req.params,
                authorization: req.headers.Authorization
            }),
        }
    ),
    headers: {
        common: {
            buildTime: environment.buildTime,
            versionNumber:  environment.versionNumber
        }
    },
    paramsSerializer: (params) => qs.stringify(params, {arrayFormat: 'repeat'}),
    responseType: 'json'
});

sentinelMw.interceptors.request.use((config) =>
    middlewareRequestInterceptor(require('../../stores/index').store, config)
);

sentinelMw.interceptors.response.use(
    (response) =>
        middlewareResponseInterceptor(
            require('../../stores/index').store,
            response
        ) as Promise<AxiosResponse>,
    (response) =>
        middlewareResponseErrorInterceptor(
            require('../../stores/index').store,
            response
        )
);

export default sentinelMw;
